const data = {
  id: 1,
  title: 'Read and choose the correct answer.',
  subTitle: 'Đọc và chọn đáp án đúng.',
  questionText: '',
  question: "Nam's flat is ______.",
  answers: [
    { id: 1, answer: 'modern and big', isCorrect: true },
    { id: 2, answer: 'small and modern', isCorrect: false },
    { id: 3, answer: 'big and old', isCorrect: false },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      direction: 'vertical',
    },
  },
};

export default data;
